import { selectTranslations } from 'store/slices/GeneralTranslationsSlice';
import { useSelector } from 'react-redux';

export const ThankYouPage = () => {
    const {
        cta_thanks_title,
        cta_thanks_description,
        cta_thanks_image,
        cta_thanks_social_text,
        footer_instagram_link,
        footer_facebook_link,
        footer_youtube_link,
    } = useSelector(selectTranslations);

    return (
        <div className="thankyou-container">
            <div className="thankyou-wrapper" style={cta_thanks_image ? { backgroundImage: `url("${cta_thanks_image}")` } : {}}>
                <div className="thankyou-background">
                    <h3>{cta_thanks_title}</h3>
                    <p className="body1">{cta_thanks_description}</p>
                    <div className="thankyou-bottom-wrapper">
                        <div className="thankyou-background-bottom">
                            <p className="body1">{cta_thanks_social_text}</p>
                            <div className="social-buttons">
                                {footer_instagram_link && <a target="_blank" rel="noreferrer" href={footer_instagram_link} className="button instagram" />}
                                {footer_facebook_link && <a target="_blank" rel="noreferrer" href={footer_facebook_link} className="button facebook" />}
                                {footer_youtube_link && <a target="_blank" rel="noreferrer" href={footer_youtube_link} className="button youtube" />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
